import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const prefixUrl = '/api';

  const assetsPrefix = '/assets';

  const token = authService.getUser()?.jwt;

  // Clone request and add Authorization header
  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
        url:
          req.url.startsWith(prefixUrl) || req.url.startsWith(assetsPrefix)
            ? req.url
            : `${prefixUrl}${req.url}`,
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout();
      }

      return throwError(() => error);
    }),
  );
};
